import React from 'react';
import { Row, Col, Divider } from 'antd';
import { useTranslation } from 'react-i18next';

const BankTransferInfo = ({ campaign, domain, bankData }) => {
  const { t } = useTranslation();

  return (
    <Row type="flex" align="top" justify="start" className="content-row">
      <Divider className="divider-payment" />
      <Col className="card" xs={24} sm={24} md={24} lg={24} xl={24}>
        <div className="ant-collapse-sub-header" style={{ paddingLeft: '10px' }}>
          {t('Bank data')}
        </div>
        <p style={{ marginLeft: '10px' }}>
          {t('Please make a transfer to the following account, and put the number as a reference')}:{' '}
          <b>{campaign.id}</b>.
          <br />
          <br />
          <div>
            {domain === 'duoPrint'
              ? 'DUOPRINT-G S.A. - R.U.C.: 0992670835001'
              : campaign.invoice_issuing.business.name +
                ' - CUIT: ' +
                campaign.invoice_issuing.business.tax_id}
          </div>
          <div>
            <br />
            {t('Bank data')}:
            <div style={{ marginLeft: '10px' }}>
              {bankData.map((data, i) => (
                <span key={i}>
                  {data}
                  <br />
                </span>
              ))}
            </div>
          </div>
        </p>
      </Col>
    </Row>
  );
};

export default BankTransferInfo;
